import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";

export default function NewsFlash() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 6);

  return (
    <section className="container-page mt-12 md:mt-16">
      <SectionHeading
        icon="ri-newspaper-line"
        title="最新影视资讯速递"
        subtitle="聚焦行业动态、深度影评与热门专题，掌握第一手影视风向"
        moreLink="/news"
        moreText="全部资讯"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <Link
          to={`/news/${featured.id}`}
          className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100"
        >
          <div className="relative h-56 w-full overflow-hidden md:h-full md:min-h-[320px]">
            <img
              src={featured.cover}
              alt={`${featured.title} 资讯配图`}
              title={`${featured.title} 影视资讯`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-primary-950">
              {featured.category}
            </span>
            <h3 className="mt-2.5 text-lg font-semibold leading-snug text-background-50 md:text-xl">
              {featured.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-xs text-background-300 md:text-sm">{featured.summary}</p>
            <div className="mt-3 flex items-center gap-3 text-[11px] text-background-400">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-user-line" />
                {featured.author}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-calendar-line" />
                {featured.date}
              </span>
            </div>
          </div>
        </Link>

        <ul className="flex flex-col gap-3">
          {rest.map((item) => (
            <li key={item.id}>
              <Link
                to={`/news/${item.id}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 hover:bg-background-100 md:p-4"
              >
                <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-20 md:w-32">
                  <img
                    src={item.cover}
                    alt={`${item.title} 资讯配图`}
                    title={`${item.title} 影视资讯`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-400">
                    <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
                      {item.category}
                    </span>
                    <span className="whitespace-nowrap">{item.date}</span>
                  </div>
                  <h4 className="mt-1.5 line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h4>
                </div>
                <i className="ri-arrow-right-line mt-1 shrink-0 text-lg text-foreground-300 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}